// extracted by mini-css-extract-plugin
module.exports = {"sameLine":"basicCard_sameLine__3_eu5","topMargin":"basicCard_topMargin__MqqWS","button":"basicCard_button__3susz","noTopMargin":"basicCard_noTopMargin__fMGJD"};